var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-google-autocomplete',{staticClass:"autocomplete-input",attrs:{"id":"map","append-icon":"mdi-map-marker","placeholder":_vm.$t('receiveHelp.locationPlaceholder'),"value":_vm.defaultValue},on:{"placechanged":_vm.getAddressData}})}
var staticRenderFns = []

export { render, staticRenderFns }